import { render, staticRenderFns } from "./BreakCard.vue?vue&type=template&id=021b0573&scoped=true&"
import script from "./BreakCard.vue?vue&type=script&lang=js&"
export * from "./BreakCard.vue?vue&type=script&lang=js&"
import style0 from "./BreakCard.vue?vue&type=style&index=0&id=021b0573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021b0573",
  null
  
)

export default component.exports